import React, { useMemo, useRef } from 'react';
import HealthBundleInner from './HealthBundleInner';
import { BundleSection, BundleWrapper } from './styled';

export default function HealthBundle(props) {
  const {
    data,
    productId,
    isFertilityProduct,
    lactoMama,
    lactoMamaCategory,
    setSelectedVariant,
    variantPriceData,
    setAddProductToCartOnVariantClick,
    stretchMarks,
    isPopUp,
    handleClose,
    isDetergentProduct,
    userType,
  } = props;
  const bundleRef = useRef();
  const selectedTitle = useMemo(() => {
    let title = '';
    data?.map((element) => {
      if (element?.id == productId) {
        title = element?.title;
      }
    });
    return title;
  }, [data, productId]);

  //const getPack = productId == "3408" ? "1" : productId == "3663" ? "3" : "2";
  return (
    <BundleWrapper lactoMama={lactoMama} lactoMamaCategory={lactoMamaCategory} suppressHydrationWarning>
      {!isPopUp && (
        <div className="heading" suppressHydrationWarning>
          {lactoMamaCategory ? 'Select your pack:' : 'Pack Size:'}{' '}
          {selectedTitle}
        </div>
      )}
      <BundleSection
        ref={bundleRef}
        isFertilityProduct={isFertilityProduct}
        lactoMamaCategory={lactoMamaCategory}
      >
        {data?.map((element, index) => {
          return (
            <HealthBundleInner
              element={element}
              productId={productId}
              index={index}
              key={`bundle_${index}`}
              isFertilityProduct={isFertilityProduct}
              bundleRef={bundleRef}
              lactoMama={lactoMama}
              lactoMamaCategory={lactoMamaCategory}
              setSelectedVariant={setSelectedVariant}
              productPriceData={variantPriceData?.find(
                (ele) => ele.product_id == element.id,
              )}
              setAddProductToCartOnVariantClick={
                setAddProductToCartOnVariantClick
              }
              stretchMarks={stretchMarks}
              handleClose={handleClose}
              isPopUp={isPopUp}
              isDetergentProduct={isDetergentProduct}
              userType={userType}
            />
          );
        })}
      </BundleSection>
    </BundleWrapper>
  );
}
